import { render } from "./ToastHost.vue?vue&type=template&id=c8838c78&scoped=true"
import script from "./ToastHost.vue?vue&type=script&lang=js"
export * from "./ToastHost.vue?vue&type=script&lang=js"

import "./ToastHost.vue?vue&type=style&index=0&id=c8838c78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8838c78"]])

export default __exports__